import { useQuery } from "@tanstack/react-query";
import { fetchFacets } from "../lib/api";

// Source + category option lists with counts. Sources depend only on the shelf;
// categories also narrow by the selected source (the API encodes both rules).
export function useFacets(shelf: string, source: string) {
  return useQuery({
    queryKey: ["facets", shelf, source],
    queryFn: () => fetchFacets(shelf, source),
    placeholderData: (prev) => prev,
  });
}
